import React from 'react';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import Modal from '../../../../components/Modal';
import Toggle from '../../../../components/Toggle';
import { useFirmwareUpdateStore } from './state/use-firmware-update-store';

const FirmwareUpdateModal = () => {
  const { isOpen, serialNumber, allowed, error, close, toggleAllowed } = useFirmwareUpdateStore();

  return (
    <Modal
      showModal={isOpen}
      setShowModal={close}
      title="Обновление устройства"
      showSave={false}
      error={error}
      classWidth="relative w-11/12 max-w-md my-6 mx-3">
      <div className="space-y-5 text-gray-700">
        <div className="flex items-start gap-x-3 p-4 rounded-2xl bg-orange-50">
          <WarningAmberRoundedIcon className="text-orange-500 shrink-0" />
          <div className="space-y-1">
            <p className="font-semibold text-gray-800">Доступно обновление устройства</p>
            <p className="text-sm text-gray-600">Для контроллера {serialNumber ? `«${serialNumber}»` : ''} доступна новая версия.</p>
          </div>
        </div>

        <Toggle label="Разрешить обновление устройства?" value={allowed} onChange={toggleAllowed} textOn="Да" textOff="Нет" />
      </div>
    </Modal>
  );
};

export default FirmwareUpdateModal;
